export default __webpack_public_path__ + "static/media/telemedicina-agendamento-lg.64071f43.png";